import { Project } from '@/shared/types/Project';

import { adaptProject } from './adaptProject';

export const adaptProjectList = (projects: Omit<Project, 'adaptedData'>[]) => {
  const projectList = projects.map(adaptProject);
  return projectList.sort((a, b) => +new Date(b.created_date) - +new Date(a.created_date));
};
